/* Fashion Tastemakers — shared global behavior: scroll-reveal + wishlist (localStorage, v1) */
(function () {
  'use strict';

  var WISH_KEY = 'ft:wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISH_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    localStorage.setItem(WISH_KEY, JSON.stringify(list));
    updateWishCounts(list.length);
  }

  function isWished(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWish(handle) {
    var list = getWishlist();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    setWishlist(list);
    return list.indexOf(handle) !== -1;
  }

  function updateWishCounts(count) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function paintButton(btn, wished) {
    btn.dataset.wished = wished ? 'true' : 'false';
    var onGlyph = btn.getAttribute('data-glyph-on') || '♥';
    var offGlyph = btn.getAttribute('data-glyph-off') || '♡';
    var glyphEl = btn.querySelector('[data-wish-glyph]');
    if (glyphEl) glyphEl.textContent = wished ? onGlyph : offGlyph;
    var labelEl = btn.querySelector('[data-wish-label]');
    if (labelEl) {
      labelEl.textContent = wished
        ? labelEl.getAttribute('data-label-on') || 'In wishlist'
        : labelEl.getAttribute('data-label-off') || 'Add to wishlist';
    }
  }

  function initWishButtons(scope) {
    (scope || document).querySelectorAll('[data-wish-toggle]').forEach(function (btn) {
      if (btn.dataset.ftWishBound) return;
      btn.dataset.ftWishBound = 'true';
      var handle = btn.getAttribute('data-product-handle');
      paintButton(btn, isWished(handle));
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        paintButton(btn, toggleWish(handle));
      });
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  function init(scope) {
    updateWishCounts(getWishlist().length);
    initWishButtons(scope);
    if (!scope) initReveal();
  }

  window.FT = window.FT || {};
  window.FT.wishlist = { isWished: isWished, toggle: toggleWish, count: function () { return getWishlist().length; } };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { initWishButtons(e.target); });
})();
